export enum CapabilityDataType {
  boolean = "boolean",
  number = "number",
}

export const CapabilityDataTypes = [
  { value: CapabilityDataType.boolean, label: "boolean" },
  { value: CapabilityDataType.number, label: "number" },
];
